import { render, staticRenderFns } from "./BER.vue?vue&type=template&id=43b4e181"
import script from "./BER.vue?vue&type=script&lang=js"
export * from "./BER.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports